// src/store/reducers/authReducer.js

import { LOGIN_SUCCESS, LOGOUT } from '../../store/action/authAction';

const initialState = {
  isAuthenticated: !!localStorage.getItem('userDetails'),
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
      };
    case LOGOUT:
      localStorage.removeItem('userDetails');
      return {
        ...state,
        isAuthenticated: false,
      };
    default:
      return state;
  }
};

export default authReducer;
